import React from 'react'

function Footer() {
    return (
        <footer className="main-footer">
            <strong>Copyright &copy; 2024-2025 <a href="https://v4sureitsolutions.com/">V4SUREITSOLUTIONS</a>.</strong>
            All rights reserved.
            <div className="float-right d-none d-sm-inline-block">
                <b>Version</b> 3.0.1
            </div>
        </footer>
    )
}

export default Footer